import { routerMapping } from '@/router/routerMapping';
import myMenu from '@/router/menu.json';
import $api from '../../assets/api/index';

const actions = {
  GET_USER_PROFILE({ commit }) {
    return new Promise((resolve) => {
      $api.user.GetUserProfile().then((res) => {
        const { code, result } = res;
        if (code === 200) {
          const lang = localStorage.getItem('language') || result.language;
          localStorage.setItem('language', lang);

          commit('SET_USER_PROFILE', result);
        }
        resolve(true);
      });
    });
  },
  GET_USER_MODULES({ commit }) {
    return new Promise((resolve, reject) => {
      $api.user.GetModules().then((res) => {
        const { code, result } = res;
        if (code === 200) {
          const menuTree = routerMapping(result, 'index');
          if (process.env.VUE_APP_ENV === 'development') {
            myMenu.forEach((e) => {
              menuTree[0].children.push(e);
            });
          }
          commit('SET_USERMODULES', menuTree);
          resolve(menuTree);
        }
      }).catch((err) => {
        reject(err);
      });
    });
  },
  GET_CHOICE_MODULES({ commit }) {
    return new Promise((resolve, reject) => {
      $api.user.GetChoiceModules().then((res) => {
        const { code, result } = res;
        if (code === 200) {
          const menuTree = routerMapping(result, 'choice');
          if (process.env.VUE_APP_ENV === 'development') {
            myMenu.forEach((e) => {
              menuTree[0].children.push(e);
            });
          }
          commit('SET_USERMODULES', menuTree);
          resolve(menuTree);
        }
      }).catch((err) => {
        reject(err);
      });
    });
  },
};

const mutations = {
  SET_USERMODULES(state, payload) {
    state.modules = payload;
  },
  SET_USER_PROFILE(state, payload) {
    state.userInfo = payload;
  },
};

const state = {
  modules: [],
  userInfo: {},
  themeList: [
    {
      text: '預設主題', value: 'theme-default', color: '#FB966E', subColor: '#FEEEE8', thirdColor: '#FFF7F3',
    },
    {
      text: '深色主題', value: 'theme-deep', color: '#4C4C4C', subColor: '#E6E6E6', thirdColor: '#F2F2F2',
    },
    {
      text: '主題一', value: 'theme-pink', color: '#FC8099', subColor: '#FFEBEF', thirdColor: '#FFF5F7',
    },
    {
      text: '主題二', value: 'theme-blue', color: '#4098E6', subColor: '#C3D7E9', thirdColor: '#E2F2FF',
    },
  ],
};

const getters = {
  userStyle: (state) => {
    let themeColorItem = { color: '#FB966E', subColor: '#FEEEE8', thirdColor: '#FFF7F3' };
    if (state.userInfo.userStyle) {
      const currentTheme = state.themeList.find((item) => item.value === state.userInfo.userStyle);
      try {
        const { color, subColor, thirdColor } = currentTheme;
        themeColorItem = { color, subColor, thirdColor };
      } catch (error) {
        themeColorItem = { color: '#FB966E', subColor: '#FEEEE8', thirdColor: '#FFF7F3' };
      }
    }
    return themeColorItem;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
